import { combineReducers } from 'redux';

import duplicate from './duplicate';

export default combineReducers({
  duplicate,
});
